import SectionHeading from '@/components/base/SectionHeading';
import { siteTimeline } from '@/mocks/site';

export default function TimelineSection() {
  return (
    <section className="w-full border-y border-secondary-200 bg-secondary-100">
      <div className="mx-auto max-w-content px-4 py-14 md:px-8 md:py-20">
        <SectionHeading
          eyebrow="档案时间轴"
          title="三十余年，档案是这样长出来的"
          description="从最早的通讯稿索引，到如今两千余项可公开核对的条目，整理方法本身也留下了一条清晰的时间线。"
        />

        <ol className="mt-12 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {siteTimeline.map((event) => (
            <li
              key={event.year}
              className="group flex flex-col rounded-lg border border-secondary-200 bg-background-50 p-6 transition-colors hover:border-primary-300"
            >
              <div className="flex items-center gap-3">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-700 font-heading text-sm font-bold text-background-50">
                  {event.year}
                </span>
                <span className="h-px flex-1 bg-secondary-200"></span>
              </div>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">
                {event.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{event.desc}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}